


import Header from "../components/header";
import Footer from "../components/footer";
import Contact from '../components/contactform';


export default function Contacts() {

    return (
   <div className="dody-container">
     <Header />
     <section>
         <div className="biome biome-24">
             <div
                 className="biome-element biome-element-d2ebcd8 biome-element-d2ebc99 e-flex e-con-boxed e-con e-parent e-lazyloaded biome-kit-5-sticky">

                 <div className="e-con-inner">
                     <div className="biome-element biome-element-6ea5a01 e-con-full e-flex e-con e-child">

                         <div
                             className="biome-element biome-element-87b503c biome-widget biome-widget-elementskit-heading animated fadeInUp">
                             <div className="biome-widget-container">
                                 <div className="ekit-wid-con">
                                     <div
                                         className="ekit-heading elementskit-section-title-wraper text_center   ekit_heading_tablet-   ekit_heading_mobile-text_center">
                                         <h1
                                             className="ekit-heading--title elementskit-section-title animation__char_come">
                                             Escape to <span><span>Nature</span></span>, Stay in <span><span>Comfort</span></span>
                                         </h1>
                                         <p className="attr-h3 attr-text-white title-anim">Every detail, from the rustic
                                             wooden beams to the scent of fresh wildflowers in your room, reflects our love for
                                             this land and our desire to share its beauty with others. Whether you’re
                                             seeking adventure, relaxation, or inspiration, we invite you to make
                                             memories here that last a lifetime.</p>
                                     </div>
                                 </div>
                             </div>
                         </div>

                     </div>

                 </div>
             </div>
             <Contact />
         </div>
     </section>
     <Footer />
 </div>
    )
}